/** @file The panel action of an analysis fn (AUTORIG_ACTIONS lists every fn once). */
import type { AutorigFn } from '@pose2d/api/autorig/autorigFns';
import { invariant } from '@pose2d/std/invariant';
import { AUTORIG_ACTIONS } from './autorigActions.data';
import type { AutorigAction } from './autorigTypes';

const ACTIONS: readonly AutorigAction[] = AUTORIG_ACTIONS;

/** Throws (programming error) for a fn the table lacks; autorigActions.test.ts pins the table against the api. */
export function actionOf(fn: AutorigFn): AutorigAction {
  const action = ACTIONS.find((a) => a.fn === fn);
  invariant(action !== undefined, `no auto-rig action for ${fn}`);
  return action;
}
